// Copyright 2016 Sorama B.V.

import { PLATFORM, transient } from "aurelia-framework";
import { ConfiguresRouter, Router, RouterConfiguration } from "aurelia-router";

@transient()
export class WorkflowViewShell implements ConfiguresRouter {
    public configureRouter(config: RouterConfiguration, router: Router): void {
        // Redirect all child routes to the WorkflowView
        // This must be done in a separate module (i.e. not in WorkflowView), or Aurelia will infinitely
        // try to resolve WorkflowView to itself. We do want a child router, so that the WorkflowRouter
        // can distill the WorkflowModules from the fragment without having to string-manipulate to remove
        // the path to this workflow.
        config.map([
            {
                route: ["", "**"],
                moduleId: PLATFORM.moduleName("libraries/WorkflowFramework/WorkflowRouter/WorkflowRouter"),
                nav: false,
            },
        ]);
    }
}
